import React from "react";
import { useTranslation } from "react-i18next";

import "./DatenschutzContent.scss";

const DatenschutzContent = () => {
    const { t } = useTranslation();

    return (
        <section className="datenschutz-content">
            <div className="datenschutz-content__container">

                {/* HERO */}

                <div className="datenschutz-hero__container">
                    <p className="datenschutz-hero__eyebrow">
                        {t("datenschutz.hero.eyebrow")}
                    </p>

                    <h1>
                        {t("datenschutz.hero.title")}
                    </h1>

                    <p className="datenschutz-hero__text">
                        {t("datenschutz.hero.text")}
                    </p>
                </div>

                {/* 1. VERANTWORTLICHER */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.responsible.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.responsible.intro")}
                    </p>

                    <div className="datenschutz-info-box">
                        <h3>
                            Zahnärztliche Gemeinschaftspraxis
                            Pankraz &amp; Lichagin
                        </h3>

                        <p>
                            Frau Tatjana Pankraz und Herr Sergey Lichagin
                            <br />
                            Elverdisser Straße 42
                            <br />
                            33729 Bielefeld
                        </p>

                        <p>
                            Telefon:{" "}
                            <a href="tel:+495217708288">
                                0521 / 77 08 288
                            </a>
                            <br />
                            Fax: 0521 / 77 08 290
                            <br />
                            E-Mail:{" "}
                            <a href="mailto:info@zahnarztpraxispankrazlichagin.com">
                                info@zahnarztpraxispankrazlichagin.com
                            </a>
                        </p>
                    </div>
                </section>

                {/* 2. ALLGEMEINE HINWEISE */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.general.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.general.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.general.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.general.p3")}
                    </p>
                </section>

                {/* 3. WEBSITE */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.website.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.website.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.website.intro")}
                    </p>

                    <ul>
                        <li>{t("datenschutz.sections.website.items.ip")}</li>
                        <li>{t("datenschutz.sections.website.items.date")}</li>
                        <li>{t("datenschutz.sections.website.items.pages")}</li>
                        <li>{t("datenschutz.sections.website.items.browser")}</li>
                        <li>{t("datenschutz.sections.website.items.os")}</li>
                        <li>{t("datenschutz.sections.website.items.referrer")}</li>
                        <li>{t("datenschutz.sections.website.items.connection")}</li>
                    </ul>

                    <p>
                        {t("datenschutz.sections.website.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.website.legal")}
                    </p>
                </section>

                {/* 4. HOSTING */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.hosting.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.hosting.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.hosting.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.hosting.p3")}
                    </p>

                    <p>
                        {t("datenschutz.sections.hosting.p4")}
                    </p>

                    <p>
                        {t("datenschutz.sections.hosting.p5")}
                    </p>

                    <p>
                        {t("datenschutz.sections.hosting.p6")}
                    </p>

                    <a
                        className="datenschutz-external-link"
                        href="https://all-inkl.com/datenschutzinformationen"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("datenschutz.sections.hosting.link")}
                    </a>
                </section>

                {/* 5. KONTAKT */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.contact.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.contact.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.contact.intro")}
                    </p>

                    <ul>
                        <li>{t("datenschutz.sections.contact.items.name")}</li>
                        <li>{t("datenschutz.sections.contact.items.email")}</li>
                        <li>{t("datenschutz.sections.contact.items.phone")}</li>
                        <li>{t("datenschutz.sections.contact.items.message")}</li>
                        <li>{t("datenschutz.sections.contact.items.time")}</li>
                    </ul>

                    <p>
                        {t("datenschutz.sections.contact.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.contact.legal")}
                    </p>
                </section>

                {/* 6. KONTAKTFORMULAR */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.contactForm.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.contactForm.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.contactForm.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.contactForm.p3")}
                    </p>

                    <p>
                        {t("datenschutz.sections.contactForm.p4")}
                    </p>
                </section>

                {/* 7. EMAILJS */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.email.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.email.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.email.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.email.p3")}
                    </p>
                </section>

                {/* 8. GOOGLE MAPS */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.googleMaps.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.googleMaps.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.googleMaps.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.googleMaps.p3")}
                    </p>

                    <p>
                        {t("datenschutz.sections.googleMaps.p4")}
                    </p>

                    <p>
                        {t("datenschutz.sections.googleMaps.p5")}
                    </p>

                    <a
                        className="datenschutz-external-link"
                        href="https://policies.google.com/privacy?hl=de"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("datenschutz.sections.googleMaps.link")}
                    </a>
                </section>

                {/* 9. INSTAGRAM */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.instagram.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.instagram.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.instagram.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.instagram.p3")}
                    </p>

                    <p>
                        {t("datenschutz.sections.instagram.p4")}
                    </p>

                    <a
                        className="datenschutz-external-link"
                        href="https://privacycenter.instagram.com/policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("datenschutz.sections.instagram.link")}
                    </a>
                </section>

                {/* 10. COOKIES */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.cookies.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.cookies.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.cookies.p2")}
                    </p>

                    <p>
                        {t("datenschutz.sections.cookies.p3")}
                    </p>

                    <p>
                        {t("datenschutz.sections.cookies.p4")}
                    </p>

                    <p>
                        {t("datenschutz.sections.cookies.p5")}
                    </p>

                    <a
                        className="datenschutz-internal-link"
                        href="/cookie-einstellungen"
                    >
                        {t("datenschutz.sections.cookies.link")}
                    </a>
                </section>

                {/* 11. SPEICHERDAUER */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.storage.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.storage.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.storage.p2")}
                    </p>
                </section>

                {/* 12. RECHTE */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.rights.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.rights.intro")}
                    </p>

                    <ul>
                        <li>{t("datenschutz.sections.rights.items.access")}</li>
                        <li>{t("datenschutz.sections.rights.items.rectification")}</li>
                        <li>{t("datenschutz.sections.rights.items.deletion")}</li>
                        <li>{t("datenschutz.sections.rights.items.restriction")}</li>
                        <li>{t("datenschutz.sections.rights.items.portability")}</li>
                        <li>{t("datenschutz.sections.rights.items.objection")}</li>
                        <li>{t("datenschutz.sections.rights.items.withdrawal")}</li>
                    </ul>

                    <p>
                        {t("datenschutz.sections.rights.p1")}
                    </p>
                </section>

                {/* 13. BESCHWERDE */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.complaint.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.complaint.p1")}
                    </p>

                    <div className="datenschutz-info-box">
                        <h3>
                            {t("datenschutz.sections.complaint.authority")}
                        </h3>

                        <p>
                            Kavalleriestraße 2–4
                            <br />
                            40213 Düsseldorf
                            <br />
                            Deutschland
                        </p>
                    </div>
                </section>

                {/* 14. DATENSICHERHEIT */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.security.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.security.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.security.p2")}
                    </p>
                </section>

                {/* 15. EXTERNE LINKS */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.externalLinks.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.externalLinks.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.externalLinks.p2")}
                    </p>
                </section>

                {/* 16. ÄNDERUNGEN */}

                <section className="datenschutz-block">
                    <h2>
                        {t("datenschutz.sections.changes.title")}
                    </h2>

                    <p>
                        {t("datenschutz.sections.changes.p1")}
                    </p>

                    <p>
                        {t("datenschutz.sections.changes.p2")}
                    </p>
                </section>

                <div className="datenschutz-update">
                    {t("datenschutz.updated")}
                </div>

            </div>
        </section>
    );
};

export default DatenschutzContent;